import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';

import { environment } from '../../environments/environment';


export interface Passport {
  id: string,
  uniqueId: string,
  orgId?: string,
  roles?: string,
  groups?: string
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // private apiUrl = environment.apiUrl;
  
  constructor(public httpClient: HttpClient) {}

  getLoginUrl(): Observable<any> {
    return this.httpClient.get<any>(`/usanapi/login/url`);
    
  }
  

    getToken(data: Passport): Observable<any> {
      if (environment.securityOff) {
        return EMPTY;
      }
      return this.httpClient.post('/usanapi/passport', data);
      
    }
}
